import { Route, Switch } from 'react-router'

import { useLinkSupport } from '@signavio/effektif-commons'

import CreateCase from './CreateCase'

function Routes() {
  useLinkSupport()
  return (
    <Switch>
      <Route path="/public/start-form/:processId" component={CreateCase} />
    </Switch>
  )
}

export default Routes
